module.exports = __webpack_public_path__ + "static/media/finanziamenti-card.37b917bd.png";